<template>
  <router-view
    v-if="mounted"
    :test-campaign.sync="campaign"
    :esp-id="espId"
    :subject="subject"
    :score="score"
    :dimensions="dimensions"
  />
</template>
<script>
export default {
  props: {
    testCampaign: {
      type: Object,
      required: true,
      default: () => ({
        id: -1,
        name: '',
        tests: [],
        suggestions: {
          expectedOpenRate: 0,
          achievableOpenRate: 0
        }
      })
    },
    espId: {
      type: Number,
      required: true
    },
    subject: {
      type: String,
      required: true
    },
    score: {
      type: Number,
      required: true
    },
    dimensions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      mounted: false,
      campaign: {
        id: -1,
        name: '',
        tests: [],
        suggestions: {
          expectedOpenRate: 0,
          achievableOpenRate: 0
        }
      }
    }
  },
  mounted() {
    this.campaign = _.assign(this.testCampaign)
    this.mounted = true
  }
}
</script>